module.exports = __webpack_public_path__ + "static/img/shuizhuniurou.49b808d1.png";